import { gql, useSubscription } from '@apollo/client'

import type {
  ProblemsWidget,
  SubscriptionProblemsWidgetArgs,
} from '~/api/graphql/generated/types'

export const PROBLEMS_WIDGET_SUBSCRIPTION = gql`
  subscription ProblemsWidget(
    $patientId: ID!
    $offset: PageOffset = 0
    $limit: Int = 150
  ) {
    problemsWidget(patientId: $patientId, offset: $offset, limit: $limit) {
      problems {
        ... on SnapshotProblemLog {
          id
          date
          description
          descriptionTranslation
          notes
          business {
            id
            name
          }
          soap {
            id
            finalized
          }
          status {
            id
            name
          }
          vet {
            id
            firstName
            lastName
            email
            mobilePhone
            photo
            photoThumbnail
            deleted
          }
          type
          problemId
          enums {
            id
            problemLogId
            enumId
            enumValueId
            parentEnumValueId
            notes
            modificationDate
            creationDate
            creatorId
            modifierId
          }
        }
        ... on SnapshotDiagnosisHistory {
          id
          date
          business {
            id
            name
          }
          description
          descriptionTranslation
          diagnosedIn
          diagnosedBy
          vet {
            id
            firstName
            lastName
            email
            mobilePhone
            photo
            photoThumbnail
            deleted
          }
          diagnosisId
          previousMedicalRecordId
          status {
            id
            name
          }
          notes
        }
        ... on SnapshotMedicalHistory {
          id
          date
          business {
            id
            name
          }
          name
          details
        }
      }
      problemsCounters {
        problemCount
      }
    }
  }
`

export const useProblemsWidgetSubscription = (
  patientId: string,
  offset: number = 0,
  limit: number = 150,
) =>
  useSubscription<
    { problemsWidget: ProblemsWidget },
    SubscriptionProblemsWidgetArgs
  >(PROBLEMS_WIDGET_SUBSCRIPTION, {
    variables: { patientId, offset, limit },
    skip: !patientId,
  })
